<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState("app", [
      "adminPanel"
    ])
  }
};
</script>

<template>
  <div class="app-router-content">
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<style>
.app-router-content {
  height: 100%;
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
